import { Model } from "@vuex-orm/core";
import Article from "@models/helpers/Article";
import Accessorygroup from "@models/helpers/Accessorygroup";
import Countryprice from "@models/helpers/Countryprice";

import { executeRules, resetRules } from "@services/helpers/ruleHandler";

export default class StoredRoomArticle extends Model {
  static entity = "storedRoomArticle";

  static primaryKey = ["article_id", "room_id", "accessorygroup_id"];

  static fields() {
    return {
      article_id: this.attr(null),
      room_id: this.attr(null),
      accessorygroup_id: this.attr(null),

      quantity: this.number(null),
      positionDescription: this.attr(null),
      isUpdated: this.boolean(false),

      article: this.belongsTo(Article, "article_id"),
      accessorygroup: this.belongsTo(Accessorygroup, "accessorygroup_id"),

      status: this.string("default"),
      position: this.number(0).nullable(),
    };
  }

  getStoreId() {
    return this.room_id;
  }

  static beforeCreate(article) {
    if (article.quantity > 0 && article.isUpdated == true) {
      article.quantity = executeRules(article, "room");
      article.isUpdated = false;
    }
  }

  static beforeUpdate(article) {
    if (article.quantity > 0 && article.isUpdated == true) {
      article.quantity = executeRules(article, "room");
      article.isUpdated = false;
    }
    if (
      article.quantity == 0 &&
      article.accessorygroup_id != 1 &&
      article.isUpdated == true
    ) {
      article.quantity = resetRules(article, "room");
      article.isUpdated = false;
    }
  }

  getPrice() {
    const price = Countryprice.query()
      .where("article_id", this.article_id)
      .first();
    if (!price || !price.unit_price) return "-";
    return parseInt(price.unit_price);
  }

  getTotalPrice() {
    const price = Countryprice.query()
      .where("article_id", this.article_id)
      .first();
    if (!price || !price.unit_price) return "-";
    return parseInt(price.unit_price * this.quantity);
  }
}
